<template>
  <div
    class="recommend-module"
    ref="recommendModule"
    v-if="navList.length"
  >
    <div
      class="firstNav"
      v-if='navTitles.length'
      :class="{ firstNavNone : firstNavShow }"
    >
      <van-tabs
        @click="tab"
        class="cardList-nav"
      >
        <van-tab
          :key="index"
          :title="item.title"
          v-for="(item, index) in navTitles"
        ></van-tab>
      </van-tabs>
    </div>
    <div
      class="columnNav bg"
      v-show='navIndex===0'
    >
      <!-- v-model="current" -->
      <van-tabs
        :ellipsis="false"
        :lazy-render="true"
        :offset-top="offsetTop"
        :sticky="true"
        :title-active-color="navTab.fontColor"
        :title-inactive-color="navTab.fontColor"
        color="#bc7650"
        @change="switchTab"
        class="nav"
        ref="nav"
        v-if='reset'
      >
        <van-tab
          :key="index"
          class="tab-item"
          v-for="(tabName, index) in navList"
        >
          <div slot='title'>
            <img
              class="navImg"
              :src='tabName.configer.img'
            />
            {{tabName.configer.title}}
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div
      class="priceNav bg"
      v-show='navIndex===1'
    >
      <!-- v-model="PriceCurrent" -->
      <van-tabs
        @change="switchPriceTab"
        v-if='reset'
        :ellipsis="false"
      >
        <van-tab
          :key="index"
          :title="item.name"
          v-for="(item, index) in priceList"
        ></van-tab>
      </van-tabs>
    </div>
    <div class="product-lists">
      <div
        class="tab-content"
        v-show="contList.length"
      >
        <van-list
          :finished="finished"
          @load="onLoad"
          finished-text="没有更多了"
          v-model="loading"
        >
          <div class="product-list">
            <product-list
              :sku-list="contList"
              :border-img="borderImg"
              v-if="contList.length"
            ></product-list>
          </div>
        </van-list>
      </div>
      <p
        class="noData"
        v-if='noDataShow'
      >没有更多了</p>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, List } from 'vant'
import ProductList from '@/components/ProductDoubleEach'
// import api from '../utils/api'
let flag = false
let timer = null
export default {
  name: 'recommendModule',
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    VanList: List,
    ProductList
  },
  props: {
    navList: {
      type: Array
    },
    priceList: {
      type: Array
    },
    navTitles: {
      type: Array
    },
    offsetTop: {
      type: Number,
      default: 0
    },
    borderImg: {
      type: String
    }
  },
  data () {
    return {
      navTab: {
        lineColor: '#DDB885',
        fontColor: '#404040'
      },
      navIndex: 0,
      clientHeight: 0,
      current: 0,
      PriceCurrent: 0,
      column: 0,
      loading: false,
      finished: false,
      pageNum: 1,
      contList: [],
      csid: [],
      minPrice: 0,
      maxPrice: '',
      reset: true,
      firstNavShow: false,
      noDataShow: false
    }
  },
  watch: {
    // current (newVal) {
    //   this.noDataShow = false
    //   this.contList = []
    //   this.finished = false
    //   this.pageNum = 1
    //   clearTimeout(timer)
    //   timer = setTimeout(() => {
    //     this.getContList(this.column, this.pageNum)
    //   }, 150)
    // },
    PriceCurrent (newVal) {
      // this.noDataShow = false
      // this.contList = []
      // this.finished = false
      // this.pageNum = 1
      // clearTimeout(timer)
      // timer = setTimeout(() => {
      //   this.getContList(this.column, this.pageNum, this.minPrice, this.maxPrice)
      // }, 150)
    }
  },
  created () {
    if (this.$route.query.title === '办公用品') {
      this.firstNavShow = true
    }
  },
  mounted () {
    this.clientHeight = document.documentElement.clientHeight
    for (let i in this.navList) {
      this.csid.push(this.navList[i].configer.column)
    }
    this.column = this.navList[0].configer.column
    sessionStorage.setItem('csid', JSON.stringify(this.csid))
    if (this.$route.query.title === '办公用品') {
      const navItem = { name: '', configer: { title: '全部', column: this.csid.join(','), sort: '' }, code_name: '企业慧采专区-办公用品分类' }
      this.navList.unshift(navItem)
    }
  },
  methods: {
    // 一级菜单
    tab (index, title) {
      this.reset = false
      this.navIndex = index
      this.noDataShow = false
      this.contList = []
      this.finished = false
      this.pageNum = 1
      if (index === 0) {
        this.getContList([this.column], this.pageNum)
        this.csid = []
        for (let i in this.navList) {
          this.csid.push(this.navList[i].configer.column)
        }
      } else if (index === 1) {
        let NumStr = this.priceList[0].name
        let NumValue = NumStr.split('元')[0].split('-')
        if (NumValue.length < 2) {
          this.minPrice = 0
          this.maxPrice = NumValue[0]
        } else {
          this.minPrice = NumValue[0]
          this.maxPrice = NumValue[1]
        }
        this.getContList(this.csid, this.pageNum, this.minPrice, this.maxPrice)
      } else if (index === 2) {
        this.csid = [this.navTitles[2].column]
        this.getContList(this.csid, this.pageNum)
      }
      setTimeout(() => {
        this.reset = true
      }, 50)
    },
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        if (this.navIndex !== 1) {
          if (this.$route.query.title === '办公用品') {
            if (this.current === 0) {
              this.getContListAll(this.navList[this.current].configer.column, ++this.pageNum).then(() => {
                setTimeout(() => {
                  this.loading = false
                  flag = false
                }, 500)
              })
            } else {
              this.getContList([this.navList[this.current].configer.column], ++this.pageNum).then(() => {
                setTimeout(() => {
                  this.loading = false
                  flag = false
                }, 500)
              })
            }
          } else {
            this.getContList([this.navList[this.current].configer.column], ++this.pageNum).then(() => {
              setTimeout(() => {
                this.loading = false
                flag = false
              }, 500)
            })
          }
        } else {
          this.getContList(this.csid, ++this.pageNum, this.minPrice, this.maxPrice).then(() => {
            setTimeout(() => {
              this.loading = false
              flag = false
            }, 500)
          })
        }
      }, 300)
    },
    // 二级分类
    switchTab (i) {
      this.$toast.loading('正在加载...')
      this.current = i
      this.noDataShow = false
      this.contList = []
      this.finished = false
      this.pageNum = 1
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.column = this.navList[i].configer.column
        if (this.$route.query.title === '办公用品') {
          if (i === 0) {
            this.getContListAll(this.column, this.pageNum)
          } else {
            this.getContList([this.column], this.pageNum)
          }
        } else {
          this.getContList([this.column], this.pageNum)
        }
      }, 10)
      // this.column = this.navList[i].configer.column
    },
    // 二级价格
    switchPriceTab (index, tit) {
      this.$toast.loading('正在加载...')
      this.PriceCurrent = index
      this.noDataShow = false
      this.contList = []
      this.finished = false
      this.pageNum = 1
      let arr = tit.split('元')[0].split('-')
      if (index < this.priceList.length - 1 && arr.length < 2) {
        this.minPrice = 0
        this.maxPrice = arr[0]
      } else if (index === this.priceList.length - 1 && arr.length < 2) {
        this.minPrice = arr[0]
        this.maxPrice = 99999999
      } else {
        this.minPrice = arr[0]
        this.maxPrice = arr[1]
      }
      setTimeout(() => {
        this.getContList(this.csid, this.pageNum, this.minPrice, this.maxPrice)
      }, 10)
    },

    /**
     * '获取商品列表
    */
    // async getContList (id, pageNum, minPrice, maxPrice) {
    //   const res = await api.getProductList({ id, pageNum, minPrice, maxPrice })
    //   if (res.status === 200) {
    //     this.$toast.clear()
    //     const { code, data, msg } = res.data
    //     flag = false
    //     if (code === 0) {
    //       if (pageNum === 1) {
    //         this.contList = data
    //       } else {
    //         this.contList = [...this.contList, ...data]
    //       }
    //     } else if (code === 9006) {
    //       this.finished = true
    //     } else {
    //       this.finished = true
    //       this.$toast(msg)
    //     }
    //     if (this.contList.length < 1) {
    //       setTimeout(() => {
    //         this.noDataShow = true
    //       }, 600)
    //     }
    //   }
    // },
    async getContListAll (id, pageNum, minPrice, maxPrice) {
      const res = await this.$axios.get('api/goods/categorySearchAll', { params: { csid: id, page: pageNum, min_price: minPrice, max_price: maxPrice } })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        flag = false
        if (code === 0) {
          if (pageNum === 1) {
            this.contList = data
          } else {
            this.contList = [...this.contList, ...data]
          }
        } else if (code === 9006) {
          this.finished = true
        } else {
          this.finished = true
          this.$toast(msg)
        }
        if (this.contList.length < 1) {
          setTimeout(() => {
            this.noDataShow = true
          }, 600)
        }
      }
    },
    async getContList (id, pageNum, minPrice, maxPrice) {
      const res = await this.$axios.get('api/goods/categorySearch', { params: { csid: id, page: pageNum, min_price: minPrice, max_price: maxPrice } })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        flag = false
        if (code === 0) {
          if (pageNum === 1) {
            this.contList = data
          } else {
            this.contList = [...this.contList, ...data]
          }
        } else if (code === 9006) {
          this.finished = true
        } else {
          this.finished = true
          this.$toast(msg)
        }
        if (this.contList.length < 1) {
          setTimeout(() => {
            this.noDataShow = true
          }, 600)
        }
      }
    }
  }
}
</script>
<style lang="less">
.recommend-module .van-tab--active {
  font-weight: bold !important;
  flex: 1 0 auto !important;
}
.bg .van-tab__text {
  font-size: 0.24rem;
}
.recommend-module .van-hairline--top-bottom::after {
  border-width: 0;
}
.firstNav .van-tabs__line {
  width: 6% !important;
  background: #ddb885;
}
.firstNavNone {
  display: none;
}
.bg .van-tabs__nav {
  background-color: rgba(0, 0, 0, 0);
}
.priceNav .van-tab--active .van-tab__text {
  border-radius: 0.25rem;
  background: #fff;
  padding: 0.05rem 0.2rem;
}
.priceNav .van-tabs__wrap--scrollable .van-tab {
  flex-basis: 27% !important;
  padding: 0.05rem 0.1rem;
}
.priceNav .van-tab {
  padding: 0;
}
.columnNav .van-sticky {
  // height: 1.45rem;
}
.columnNav .van-tabs--line .van-tabs__wrap {
  height: 100% !important;
}
.columnNav .van-tab {
  line-height: 0.5rem !important;
  padding: 0.15rem 0.2rem 0 !important;
}
.bg .van-tabs__line {
  display: none;
}
</style>
<style lang="less" scoped>
.recommend-module {
  // height: 100%;
}
.nav {
  min-height: 0 !important;
  // height: 1.45rem !important;
}
.navImg {
  display: block;
  margin: 0 auto;
  width: 0.78rem;
  height: auto;
}
.product-list {
  padding: 0 0.2rem;
  display: flex;
  justify-content: space-between;
  .list-left,
  .list-right {
    display: flex;
    flex-direction: column;
  }
}
.noData {
  color: #ddb885;
  font-size: 0.32rem;
  line-height: 5.6rem;
  text-align: center;
}
</style>
